import type { RefObject } from 'react';
import gsap from 'gsap';
import { fadeTo } from 'util/animation/fade/fade';
import { isTouch } from '../../../hooks/useIsDesktopDevice';

interface NewsOverviewRefs {
  elementRef: RefObject<HTMLElement | null>;
  lineRef?: RefObject<HTMLSpanElement | null>;
  topLineRef?: RefObject<HTMLSpanElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { lineRef, topLineRef }: NewsOverviewRefs,
): void {
  if (!isTouch) {
    if (topLineRef?.current) {
      timeline.fromTo(
        topLineRef.current,
        { scaleX: 0 },
        {
          scaleX: 1,
          duration: 1,
          ease: 'Quad.easeInOut',
          clearProps: 'scaleX',
        },
      );
    }
    if (lineRef?.current) {
      timeline.fromTo(
        lineRef.current,
        { scaleX: 0 },
        {
          scaleX: 1,
          duration: 1,
          ease: 'Quad.easeInOut',
          clearProps: 'scaleX',
        },
        0.2,
      );
    }
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: NewsOverviewRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}

export function setGridHeight(
  gridRef: RefObject<HTMLDivElement | null>,
  newHeight?: boolean,
): gsap.core.Tween {
  const height = newHeight ? 'auto' : gridRef.current?.offsetHeight;
  const duration = newHeight ? 0.8 : 0;

  return gsap.to(gridRef.current, { height, duration, ease: 'Power2.easeOut' });
}
